import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditingSection } from '@app/features/questionnaire/components/questions/style-tab/section-editors/editing-section';
import { Questionnaire } from '@app/core/models/questionnaire.model';
import { buildRuntimePreviewContext } from '@app/features/questionnaire/components/questions/style-tab/preview/runtime-context.builder';
import { getWelcomePreviewData } from '@app/features/questionnaire/components/questions/style-tab/preview/preview-style.resolver';

@Component({
  selector: 'app-survey-welcome-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './survey-welcome-screen.html',
  styleUrl: './survey-welcome-screen.scss',
})
export class SurveyWelcomeScreen {
  @Input() questionnaire: Questionnaire | null = null;
  @Output() startClick = new EventEmitter<void>();

  get data() {
    if (!this.questionnaire) return null;
    const context = buildRuntimePreviewContext(
      this.questionnaire,
      EditingSection.WELCOME_SCREEN
    );
    return getWelcomePreviewData(context);
  }

  onStartClick(): void {
    this.startClick.emit();
  }
}
